var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:arrow-left-16-regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.56274 22.3144C6.21464 22.3144 5.8808 22.1761 5.63466 21.9299C5.38852 21.6838 5.25024 21.35 5.25024 21.0019C5.25024 20.6538 5.38852 20.3199 5.63466 20.0738C5.8808 19.8276 6.21464 19.6894 6.56274 19.6894H32.0174L21.436 10.1659C21.3047 10.0516 21.1974 9.91234 21.1204 9.75622C21.0434 9.60009 20.9983 9.43022 20.9876 9.25647C20.9769 9.08273 21.0009 8.9086 21.0581 8.74421C21.1153 8.57981 21.2047 8.42845 21.321 8.29893C21.4373 8.1694 21.5782 8.0643 21.7355 7.98975C21.8928 7.9152 22.0633 7.87268 22.2372 7.86467C22.4111 7.85666 22.5848 7.88332 22.7483 7.9431C22.9118 8.00288 23.0618 8.09458 23.1895 8.21287L36.3145 20.0254C36.4515 20.1485 36.5612 20.299 36.6362 20.4673C36.7112 20.6355 36.75 20.8177 36.75 21.0019C36.75 21.1861 36.7112 21.3682 36.6362 21.5365C36.5612 21.7047 36.4515 21.8553 36.3145 21.9784L23.1895 33.7909C23.0618 33.9092 22.9118 34.0009 22.7483 34.0606C22.5848 34.1204 22.4111 34.1471 22.2372 34.1391C22.0633 34.131 21.8928 34.0885 21.7355 34.014C21.5782 33.9394 21.4373 33.8343 21.321 33.7048C21.2047 33.5753 21.1153 33.4239 21.0581 33.2595C21.0009 33.0951 20.9769 32.921 20.9876 32.7473C20.9983 32.5735 21.0434 32.4036 21.1204 32.2475C21.1974 32.0914 21.3047 31.9521 21.436 31.8379L32.0174 22.3144H6.56274Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.57a74e311aa64986e48f0397a5c0c001.svg";
export { ForwardRef as ReactComponent };